import React from 'react'
import { shallow } from 'enzyme'
import ChecklistItems  from '../../features/ChecklistItems/index'

describe('ChecklistItems', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      loan: {
        checklistItems: [
          {
            rid: 1,
            description: 'Sample description',
            markAsRead: true,
          },
        ],
      },
      isBankUser: false,
      loanId: 123,
    },
    wrapper = shallow(<ChecklistItems {...props} />)
    instance = wrapper.instance()
  })

  it('should set the default states', () => {
    expect(wrapper.state('hideComplete')).toBeFalsy()
    expect(wrapper.state('items').length).toEqual(1)
  })

  describe('#render', () => {
    describe('when checked item exist', () => {
      it('should have the actionbuttons', () => {
        const showHideButton = wrapper.find('#hideComplete').at(0);
        expect(showHideButton.exists()).toBeTruthy()
      })
    })
    describe('when checked item lenth is 0', () => {
      it('should not have the actionbuttons', () => {
        props.loan.checklistItems[0].markAsRead = false;
        wrapper = shallow(<ChecklistItems {...props} />)
        instance = wrapper.instance()
        const showHideButton = wrapper.find('#hideComplete').at(0);
        expect(showHideButton.exists()).toBeFalsy()
      })
    })
  })

  describe('#onHideShowComplete', () => {
    it('should call function and change state', () => {
      const onHideShowComplete = spyOn(instance, 'onHideShowComplete')
      instance.onHideShowComplete()
      const showHideButton = wrapper.find('#hideComplete').at(0);
      showHideButton.simulate('click')
      expect(onHideShowComplete).toHaveBeenCalled()
      expect(wrapper.state('hideComplete')).toBeTruthy()
    })
  })

  describe('#onItemClick', () => {
    it('should set the item ', () => {
      props.loan.checklistItems[0].markAsRead = false;
      wrapper = shallow(<ChecklistItems {...props} />)
      instance = wrapper.instance()
      const onItemClick = spyOn(instance, 'onItemClick')
      instance.onItemClick()
      const item = wrapper.find('.itemClass').at(0);
      expect(item.props().checked).toBeFalsy()
      expect(item.props().markAsRead).toBeFalsy()
      expect(item.props().description).toEqual(props.loan.checklistItems[0].description)
      expect(onItemClick).toHaveBeenCalled()
    })
  })
})
